import { useMediaQuery, useTheme } from '@mui/material';

const useWindowResize = () => {
  const theme = useTheme();
  // MUI md breakpoint is 960px - works correctly with DevTools responsive mode
  return useMediaQuery(theme.breakpoints.up('md'));
};

export default useWindowResize;
